import Steps from "./Steps";
import Step from "./Step";
export { Step };
export default Steps;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-steps/es/index.js
// module id = 1945
// module chunks = 0